module.exports = __webpack_public_path__ + "static/media/483.904a2c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/483.png
// module id = 759
// module chunks = 0